module.exports = __webpack_public_path__ + "static/media/online-vr-tour.8aa12ee8.jpg";